import { ArrowDownToLine, ArrowUpFromLine, LayoutList, MapPin, PackagePlus, Settings, Search } from "lucide-react";
import { Link } from "wouter";
import { DashboardGrid } from "@/components/dashboard-grid";
import { LowStockPanel } from "@/components/low-stock-panel";

export function FrontpageView() {
  return (
    <main className="bg-background flex min-h-dvh items-center justify-center overflow-y-auto p-4 md:h-dvh md:overflow-hidden">
      <div className="flex w-full max-w-3xl flex-col gap-4 md:h-full md:max-h-[800px] md:gap-6">
        <div className="grid min-h-0 flex-1 grid-cols-1 items-stretch gap-4 md:grid-cols-2 md:gap-6">
          <div className="flex shrink-0 flex-col md:min-h-0 md:flex-1">
            <DashboardGrid />
          </div>
          <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
            <LowStockPanel />
          </div>
        </div>

        <div className="flex shrink-0 flex-col gap-3">
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
            <Link
              href="/checkout/device"
              className="border-border bg-card text-foreground hover:bg-accent flex items-center justify-center gap-2 rounded-xl border px-4 py-3 text-center text-sm font-medium shadow-sm transition-colors"
            >
              <ArrowUpFromLine className="text-primary h-4 w-4" />
              <span>Herausgeben</span>
            </Link>
            <Link
              href="/checkin/device"
              className="border-border bg-card text-foreground hover:bg-accent flex items-center justify-center gap-2 rounded-xl border px-4 py-3 text-center text-sm font-medium shadow-sm transition-colors"
            >
              <ArrowDownToLine className="text-primary h-4 w-4" />
              <span>Zurücknehmen</span>
            </Link>
            <Link
              href="/consumables"
              className="border-border bg-card text-foreground hover:bg-accent flex items-center justify-center gap-2 rounded-xl border px-4 py-3 text-sm font-medium shadow-sm transition-colors"
            >
              <LayoutList className="text-primary h-4 w-4" />
              <span>Verbrauchsgüter</span>
            </Link>
            <Link
              href="/location-change"
              className="border-border bg-card text-foreground hover:bg-accent flex items-center justify-center gap-2 rounded-xl border px-4 py-3 text-sm font-medium shadow-sm transition-colors"
            >
              <MapPin className="text-primary h-4 w-4" />
              <span>Standortwechsel</span>
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
            <Link
              href="/search/device"
              className="border-border bg-card text-foreground hover:bg-accent flex items-center justify-center gap-2 rounded-xl border px-4 py-3 text-sm font-medium shadow-sm transition-colors"
            >
              <Search className="text-primary h-4 w-4" />
              <span>Suchen</span>
            </Link>
            <Link
              href="/bookin/device"
              className="border-border bg-card text-foreground hover:bg-accent flex items-center justify-center gap-2 rounded-xl border px-4 py-3 text-sm font-medium shadow-sm transition-colors"
            >
              <PackagePlus className="text-primary h-4 w-4" />
              <span>Einbuchen</span>
            </Link>
            <Link
              href="/settings"
              className="border-border bg-card text-foreground hover:bg-accent flex items-center justify-center gap-2 rounded-xl border px-4 py-3 text-sm font-medium shadow-sm transition-colors"
            >
              <Settings className="text-primary h-4 w-4" />
              <span>Einstellungen</span>
            </Link>
            <div className="hidden sm:block"></div>
          </div>
        </div>
      </div>
    </main>
  );
}
